import { me } from "@api/courses/reviewStats/users/me/path";

export const users = {
  me,
};
